import React from "react"
import { Link } from "react-scroll"

const Sidebar = () => (
  <nav class="sidebar w-full lg:w-1/3">
    <ul className="pt-2 pb-2 bg-gray-500">
      <li>
        <Link
          className="p-4 hover:text-white hover:bg-gray-700"
          activeClass="active"
          to="skills"
          spy={true}
          smooth={true}
          offset={-70}
          duration={600}
        >
          Athlete Skills
        </Link>
      </li>

      <li>
        <Link
          className="p-4 hover:text-white hover:bg-gray-700"
          activeClass="active"
          to="structure"
          spy={true}
          smooth={true}
          offset={-70}
          duration={600}
        >
          Training Structure
        </Link>
      </li>
      <li>
        <Link
          className="p-4 hover:text-white hover:bg-gray-700"
          activeClass="active"
          to="events"
          spy={true}
          smooth={true}
          offset={-70}
          duration={600}
        >
          Events and Competition
        </Link>
      </li>
      <li>
        <Link
          className="p-4 hover:text-white hover:bg-gray-700"
          activeClass="active"
          to="other"
          spy={true}
          smooth={true}
          offset={-70}
          duration={600}
        >
          Other Influences
        </Link>
      </li>
    </ul>
  </nav>
)

export default Sidebar
